export enum RoomType {
  single = 'single',
  shared = 'shared',
  studio = 'studio',
}
